import React, {useState, useEffect, useRef, useMemo} from 'react';
import ajaxUtil from '../../util/ajax';
import {style} from '../../util/image';
import URLUtil from '../../util/url';
import {requestFullScreen, isFullScreen} from '../../util/index';
import {Button} from 'antd';
import './Mirrow.scss';

const {ajaxv2, DOMAIN_CURRENT} = ajaxUtil;

const Index = (props)=>{
  const {galleryid} = props.router.match.params;

  let currentURL = URLUtil(window.location.href);
  let {url, background, color, shownumber} = currentURL.query;

  const wrapper = useRef();

  const [wrapperSize, setWrapperSize] = useState({
    width:0,
    height:0
  });

  const itemSize = useMemo(()=>{
    let size = {};
    size.width = Math.round(wrapperSize.width * 0.31);
    size.height = Math.round(size.width / 16 * 9);

    return size;
  }, [wrapperSize]);

  useEffect(()=>{
    const onResize = (e)=>{
      if(wrapper && wrapper.current) {
        let width = wrapper.current.clientWidth;
        let height = Math.round(width / 16 * 9);
        setWrapperSize({
          width,
          height
        });
      }
    };

    window.addEventListener('resize', onResize);
    onResize();
    return ()=>{
      window.removeEventListener('resize', onResize);
    }
  }, [wrapper]);

  const [mode, setMode] = useState(1);
  const [list, setList] = useState([]);

  const fetchList = ()=>{
    ajaxv2({
      url:DOMAIN_CURRENT + '/api/v2/gallerymedium/list',
      method:'GET',
      data:{
        page:1,
        page_size:4,
        gallery_id:Number(galleryid),
        type:'360',
        '_order[id]':'desc'
      }
    }).then(res=>{
      let {items, total} = res;
      setList(items.map(it=>{
        if(it.options) {
          try {
            it.options = JSON.parse(it.options);
          }catch(e) {}
        }

        return it;
      }));
    });
  }

  const [time, setTime] = useState(0);
  useEffect(()=>{
    fetchList();

    let timer = window.setTimeout(()=>{
      setTime(Math.round(Date.now() / 1000));
    }, 10000);

    return ()=>{
      window.clearTimeout(timer);
    }
  }, [time]);

  const renderMode = ()=>{
    if(mode == 1) {
      return <div className="content mode1">
        <div className="list">
          {list.map(it=>{
            return <div className="item" key={it.id}>
              <div className="thumb" style={itemSize}>
                {/*<img src={style(it.thumb, 'wx_750_n')} />*/}
                <video
                  width="100%"
                  loop={true} autoPlay={true} muted={true}
                  poster={style(it.thumb, 'wx_750_n')}
                  src={`https://image6.jfoto.cn/${it.source}`}
                />
              </div>
              {Number(shownumber) ? <div className="code">
                编号：{it.options.code}
              </div> : null}
            </div>;
          })}
        </div>
        <div className="info">
          <img className="qrcode" src={`//live.jimage.cn/api/common/qrcode?url=${url}&scale=16`} />
          {Number(shownumber) ? <div className="tip">
            <p>扫码进入直播间</p>
            <p>请输入编号搜索视频</p>
            <p>视频可下载</p>
          </div> : <div className="tip">
            <p>扫码进云相册</p>
            <p>点击互动视频</p>
            <p>下载璀璨瞬间</p>
          </div>}
        </div>
      </div>
    }
    if(mode == 2) {
      return <div className="content mode2">

      </div>
    }
  };

  const [fullscreen, setFullScreen] = useState(false);
  useEffect(()=>{
    const timer = window.setInterval(()=>{
      setFullScreen(isFullScreen());
    }, 1000);

    return ()=>{
      window.clearInterval(timer);
    }
  }, [fullscreen]);

  return <div className="page-liveshow-mirrow" ref={wrapper} style={{color:`${decodeURIComponent(color)}`, backgroundImage:`url('//image1.jfoto.cn/${decodeURIComponent(background)}')`}}>
    <div className="wrapper" style={wrapperSize}>
      {renderMode()}
    </div>
    {!fullscreen ? <div className="fullscreen">
      <Button type="primary" onClick={()=>{
        requestFullScreen();
      }}>点击全屏</Button>
    </div> : null}
  </div>
};

export default Index;



// WEBPACK FOOTER //
// ./src/components/LiveShow/Mirrow.js